import './styles.scss'

import { Text, Button } from "@fragments"
import { BrowseGalleryRounded, PlayCircleOutlineRounded, SettingsRounded } from "@mui/icons-material"
import { UserAvatar } from "@components/Community"
import Parser from '@helpers/parser'

function formatDuration(seconds) {
    if (!seconds) return null;
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
}

function DurationBadge({ seconds }) {
    const label = formatDuration(seconds);
    if (!label) return null;
    return <span className="lesson-duration">{label}</span>;
}

function Portrait({ lesson, onClick, onEdit }) {
    const isFutureDate = (dateString) => {
        if (!dateString) return false;
        const date = new Date(dateString);
        const now = new Date();
        return date > now;
    };

    return (
        <div className="CustomLessonCard portrait" onClick={onClick}>
            <div className="lesson-banner">
                {isFutureDate(lesson.availability?.available_at) && <AvailableAt date={lesson.availability.available_at} />}

                {lesson.banner && <img src={lesson.banner} alt={lesson.name} style={!lesson.availability?.available ? { filter: 'grayscale(100%)' } : undefined} />}
                <div className="lesson-overlay">
                    <PlayCircleOutlineRounded className="play-lesson" />
                    <div className="description mt-1">
                        <Text.h5 className="lesson-title" value={lesson.name} />
                    </div>
                </div>

                <DurationBadge seconds={lesson.video?.duration} />

                {onEdit && (
                    <Button
                        className="lesson-settings-button"
                        onClick={(e) => {
                            e.stopPropagation()
                            onEdit(lesson)
                        }}
                        size="small"
                        icon={<SettingsRounded />}
                    />
                )}
            </div>
        </div>
    )
}

function Landscape({ lesson, onClick, onEdit }) {
    const isFutureDate = (dateString) => {
        if (!dateString) return false;
        const date = new Date(dateString);
        const now = new Date();
        return date > now;
    };

    return (
        <div className="CustomLessonCard landscape" onClick={onClick}>
            <div className="lesson-banner">

                {isFutureDate(lesson.availability?.available_at) && <AvailableAt date={lesson.availability.available_at} />}

                {lesson.banner && <img src={lesson.banner} alt={lesson.name} style={!lesson.availability?.available ? { filter: 'grayscale(100%)' } : undefined} />}

                {lesson.availability?.available && <div className="lesson-overlay">
                    <PlayCircleOutlineRounded className="play-lesson" />
                </div>}

                <DurationBadge seconds={lesson.video?.duration} />

                {onEdit && (
                    <Button
                        className="lesson-settings-button"
                        onClick={(e) => {
                            e.stopPropagation()
                            onEdit(lesson)
                        }}
                        size="small"
                        icon={<SettingsRounded />}
                    />
                )}
            </div>

            <div className="horizontal-lesson-description">
                <div className="description mt-1">
                    <Text.h5 className="lesson-title" value={lesson.name} />
                    <Text.span contrast={5} weight={300} className="lesson-description" value={lesson.description} />
                    {lesson.creator?.id && (
                        <div className="lesson-owner">
                            <UserAvatar size={20} user={lesson.creator} displayName={true} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function AvailableAt({ date }) {
    return (
        <div className='available-at'>
            <BrowseGalleryRounded fontSize='small' />
            <Text.small value={`Disponível em ${Parser.date.readable(date)}`} />
        </div>
    )
}

export default function VideoCard({ lesson, onClick, onEdit }) {
    const isLandscape = lesson?.video?.aspect_ratio > 1

    if (isLandscape) {
        return <Landscape lesson={lesson} onClick={onClick} onEdit={onEdit} />
    }

    return <Portrait lesson={lesson} onClick={onClick} onEdit={onEdit} />
}

VideoCard.Portrait = Portrait
VideoCard.Landscape = Landscape